module.exports = __webpack_public_path__ + "assets/map.e79bf848556f25af4c51f7b0f1848e72.png";